export enum OwnershipType {
  NeverOwned,
  IsOwned,
  WasOwned,
}
